import { GridLocaleText } from '@mui/x-data-grid-pro';

import getPluralForm from './getPluralForm';

// ----------------------------------------------------------------

export const GRID_LT_LOCALE_TEXT: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: 'Nėra eilučių',
  noResultsOverlayLabel: 'Rezultatų nerasta.',

  // Density selector toolbar button text
  toolbarDensity: 'Tankis',
  toolbarDensityLabel: 'Tankis',
  toolbarDensityCompact: 'Kompaktiškas',
  toolbarDensityStandard: 'Standartinis',
  toolbarDensityComfortable: 'Patogus',

  // Columns selector toolbar button text
  toolbarColumns: 'Stulpeliai',
  toolbarColumnsLabel: 'Pasirinkti stulpelius',

  // Filters toolbar button text
  toolbarFilters: 'Filtrai',
  toolbarFiltersLabel: 'Rodyti filtrus',
  toolbarFiltersTooltipHide: 'Slėpti filtrus',
  toolbarFiltersTooltipShow: 'Rodyti filtrus',
  toolbarFiltersTooltipActive: (count) =>
    getPluralForm(count, {
      one: 'aktyvus filtras',
      few: 'aktyvūs filtrai',
      many: 'aktyvių filtrų',
    }),

  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: 'Ieškoti…',
  toolbarQuickFilterLabel: 'Ieškoti',
  toolbarQuickFilterDeleteIconLabel: 'Išvalyti',

  // Export selector toolbar button text
  toolbarExport: 'Eksportuoti',
  toolbarExportLabel: 'Eksportuoti',
  toolbarExportCSV: 'Atsisiųsti kaip CSV',
  toolbarExportPrint: 'Spausdinti',
  toolbarExportExcel: 'Atsisiųsti kaip Excel',

  // Columns management text
  columnsManagementSearchTitle: 'Ieškoti',
  columnsManagementNoColumns: 'Nėra stulpelių',
  columnsManagementShowHideAllText: 'Rodyti/Slėpti viską',
  columnsManagementReset: 'Atstatyti',
  columnsManagementDeleteIconLabel: 'Išvalyti',

  // Filter panel text
  filterPanelAddFilter: 'Pridėti filtrą',
  filterPanelRemoveAll: 'Pašalinti visus',
  filterPanelDeleteIconLabel: 'Ištrinti',
  filterPanelLogicOperator: 'Loginis operatorius',
  filterPanelOperator: 'Operatorius',
  filterPanelOperatorAnd: 'Ir',
  filterPanelOperatorOr: 'Arba',
  filterPanelColumns: 'Stulpeliai',
  filterPanelInputLabel: 'Reikšmė',
  filterPanelInputPlaceholder: 'Filtro reikšmė',

  // Filter operators text
  filterOperatorContains: 'turi',
  filterOperatorDoesNotContain: 'neturi',
  filterOperatorEquals: 'lygus',
  filterOperatorDoesNotEqual: 'nelygus',
  filterOperatorStartsWith: 'prasideda',
  filterOperatorEndsWith: 'baigiasi',
  filterOperatorIs: 'yra',
  filterOperatorNot: 'nėra',
  filterOperatorAfter: 'po',
  filterOperatorOnOrAfter: 'tą pačią dieną arba po',
  filterOperatorBefore: 'prieš',
  filterOperatorOnOrBefore: 'tą pačią dieną arba prieš',
  filterOperatorIsEmpty: 'tuščias',
  filterOperatorIsNotEmpty: 'nėra tuščias',
  filterOperatorIsAnyOf: 'yra bet kuris iš',
  'filterOperator=': '=',
  'filterOperator!=': '!=',
  'filterOperator>': '>',
  'filterOperator>=': '>=',
  'filterOperator<': '<',
  'filterOperator<=': '<=',

  // Header filter operators text
  headerFilterOperatorContains: 'Turi',
  headerFilterOperatorDoesNotContain: 'Neturi',
  headerFilterOperatorEquals: 'Lygus',
  headerFilterOperatorDoesNotEqual: 'Nelygus',
  headerFilterOperatorStartsWith: 'Prasideda',
  headerFilterOperatorEndsWith: 'Baigiasi',
  headerFilterOperatorIs: 'Yra',
  headerFilterOperatorNot: 'Nėra',
  headerFilterOperatorAfter: 'Po',
  headerFilterOperatorOnOrAfter: 'Tą pačią arba po',
  headerFilterOperatorBefore: 'Prieš',
  headerFilterOperatorOnOrBefore: 'Tą pačią arba prieš',
  headerFilterOperatorIsEmpty: 'Tuščias',
  headerFilterOperatorIsNotEmpty: 'Nėra tuščias',
  headerFilterOperatorIsAnyOf: 'Bet kuris iš',
  'headerFilterOperator=': 'Lygus',
  'headerFilterOperator!=': 'Nelygus',
  'headerFilterOperator>': 'Didesnis nei',
  'headerFilterOperator>=': 'Didesnis arba lygus',
  'headerFilterOperator<': 'Mažesnis nei',
  'headerFilterOperator<=': 'Mažesnis arba lygus',

  // Filter values text
  filterValueAny: 'bet kuris',
  filterValueTrue: 'taip',
  filterValueFalse: 'ne',

  // Column menu text
  columnMenuLabel: 'Meniu',
  columnMenuShowColumns: 'Rodyti stulpelius',
  columnMenuManageColumns: 'Tvarkyti stulpelius',
  columnMenuFilter: 'Filtruoti',
  columnMenuHideColumn: 'Slėpti stulpelį',
  columnMenuUnsort: 'Panaikinti rūšiavimą',
  columnMenuSortAsc: 'Rūšiuoti didėjančiai',
  columnMenuSortDesc: 'Rūšiuoti mažėjančiai',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) =>
    getPluralForm(count, {
      one: 'aktyvus filtras',
      few: 'aktyvūs filtrai',
      many: 'aktyvių filtrų',
    }),
  columnHeaderFiltersLabel: 'Rodyti filtrus',
  columnHeaderSortIconLabel: 'Rūšiuoti',

  // Rows selected footer text
  footerRowSelected: (count) =>
    getPluralForm(count, {
      one: 'pasirinkta eilutė',
      few: 'pasirinktos eilutės',
      many: 'pasirinktų eilučių',
    }),

  // Total row amount footer text
  footerTotalRows: 'Viso eilučių:',

  // Total visible row amount footer text
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} iš ${totalCount.toLocaleString()}`,

  // Checkbox selection text
  checkboxSelectionHeaderName: 'Žymėjimas varnele',
  checkboxSelectionSelectAllRows: 'Pažymėti visas eilutes',
  checkboxSelectionUnselectAllRows: 'Nuimti žymėjimą nuo visų eilučių',
  checkboxSelectionSelectRow: 'Pažymėti eilutę',
  checkboxSelectionUnselectRow: 'Nuimti žymėjimą nuo eilutės',

  // Boolean cell text
  booleanCellTrueLabel: 'taip',
  booleanCellFalseLabel: 'ne',

  // Actions cell more text
  actionsCellMore: 'daugiau',

  // Column pinning text
  pinToLeft: 'Prisegti kairėje',
  pinToRight: 'Prisegti dešinėje',
  unpin: 'Atsegti',

  // Tree Data
  treeDataGroupingHeaderName: 'Grupė',
  treeDataExpand: 'rodyti vaikinius',
  treeDataCollapse: 'slėpti vaikinius',

  // Grouping columns
  groupingColumnHeaderName: 'Grupė',
  groupColumn: (name) => `Grupuoti pagal ${name}`,
  unGroupColumn: (name) => `Nebesigrupuoti pagal ${name}`,

  // Master/detail
  detailPanelToggle: 'Išsamios informacijos skydelio perjungimas',
  expandDetailPanel: 'Išplėsti',
  collapseDetailPanel: 'Sutraukti',

  // Used core components translation keys
  MuiTablePagination: {
    labelRowsPerPage: 'Eilučių puslapyje:',
    labelDisplayedRows: ({ from, to, count, estimated }) => {
      if (!estimated) {
        return `${from}–${to} iš ${count !== -1 ? count : `daugiau nei ${to}`}`;
      }
      const estimatedLabel =
        estimated && estimated > to ? `apie ${estimated}` : `daugiau nei ${to}`;
      return `${from}–${to} iš ${count !== -1 ? count : estimatedLabel}`;
    },
    getItemAriaLabel: (type) => {
      if (type === 'first') {
        return 'Eiti į pirmą puslapį';
      }
      if (type === 'last') {
        return 'Eiti į paskutinį puslapį';
      }
      if (type === 'next') {
        return 'Eiti į kitą puslapį';
      }
      // if (type === 'previous') {
      return 'Eiti į ankstesnį puslapį';
    },
  },

  // Row reordering text
  rowReorderingHeaderName: 'Eilučių pertvarkymas',

  // Aggregation
  aggregationMenuItemHeader: 'Agregacija',
  aggregationFunctionLabelSum: 'suma',
  aggregationFunctionLabelAvg: 'vidurkis',
  aggregationFunctionLabelMin: 'mažiausia',
  aggregationFunctionLabelMax: 'didžiausia',
  aggregationFunctionLabelSize: 'dydis',
};
